import { styled } from '../../Utilities';
import { CheckBase } from './Check.base';
import { getStyles } from './Check.styles';
export var Check = styled(CheckBase, getStyles, undefined, {
    scope: 'Check',
}, true);
//# sourceMappingURL=Check.js.map